import React, { useState, useEffect } from 'react';
import { Row, Col, Table, Card, Form, Button, Spinner } from 'react-bootstrap';
import Swal from 'sweetalert2';
import { Link, useNavigate, useParams } from 'react-router-dom';


import { useProvider, Toast } from '../../context/MenuProvider';


const BalancoDiario = () => {
  const { 
      crud,
      hasPerms,
  } = useProvider();
  const { id, tipo, categoria, modelo, ano:anoParam } = useParams();
  const [balanco, setBalanco] = useState(null)
  const [tableSelected, setTableSelected] = useState(null)
  const [ano, setAno] = useState(anoParam || new Date().getFullYear());
  const [isAcumulado, setIsAcumulado] = useState(false);
  const [isQuantidade, setIsQuantidade] = useState(false);
  const [isSoQuantidade, setIsSoQuantidade] = useState(false);
  const [anoMenu, setAnoMenu] = useState({});
  const { get, post, loading } = crud || {};
  const [, mes, dia] = new Date().toLocaleDateString('sv-SE').split('-').map(Number);
  
  useEffect(()=>{
    switch(tipo){
      case 'produtos':
        setIsQuantidade(true);
        break
      case 'rede':
        setIsQuantidade(true);
        setIsSoQuantidade(true);
        break
    }
  },[tipo, categoria, modelo, id])
  
  useEffect(()=>{
    if(tableSelected==null){
      setTableSelected(dia-1);
    }
  }, [setTableSelected])
  
  
  
  const buscarBalancoDiario = async () => {
    try{
      const response = await get(`/gvendas/relatorios/${categoria}/balanco-diario/${ano}/${tipo}/`, 'buscarBalancoDiario');
      if (response && response.length){
        setBalanco(response[0]);
        //alert(JSON.stringify(response[0]))
      }
    }catch(err){
        //alert(JSON.stringify(err.response))
    }
  }

  
  const carregarAnoMenu = (deslocamento = 0) => {
      const data = new Date(ano, 0, 1);
      data.setFullYear(data.getFullYear() + deslocamento);
      
      // Configura os valores do menu
      setAnoMenu({
        anterior: data.getFullYear()-1,
        atual: data.getFullYear(),
        proximo: data.getFullYear()+1,
      });
      setAno(data.getFullYear());
  };
  
  useEffect(()=>{
    carregarAnoMenu();
  }, [setAno])
  
  const Matriz = () => {
    const meses = [
      "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", 
      "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"
    ];
    const matriz = Array.from({ length: 31 }, () => Array(12).fill(null));
    setBalanco({
      metas:matriz[0],
      meses:meses,
      total:matriz[0],
      dias:matriz,
    })
  }
  
  useEffect(()=>{
    if(!balanco) Matriz();
    buscarBalancoDiario();
    // if(ano && categoria && tipo){
    //   buscarBalancoDiario();
    // }
  },[ano, categoria, tipo, modelo, id])
  
  const getSoma = (dia, mes) => {
    var soma = 0;
    for (let i = 0; i <= dia; i++) {
        soma+=isQuantidade?balanco.dias[i][mes]?.quantidade||0:balanco.dias[i][mes]?.valor||0;
    }
    return soma;
  }
  
  const addMeta = async(ano,mes, valorInicial) => {
    const nMes = ['Jan','Fev','Mar','Abr','Mai','Jun','Jul','Ago','Set','Out','Nov','Dez'];
    Swal.fire({
      title: `Meta de ${nMes[mes-1]}/${ano}`,
      input: "number",
      inputValue: valorInicial || 0,
      inputAttributes: {
        autocapitalize: "off",
        step: "0.01"
      },
      showCancelButton: true,
      confirmButtonText: "Salvar",
      cancelButtonText: "Cancelar",
      showLoaderOnConfirm: true,
      preConfirm: async (valor) => {
        //valor = parseFloat(valor)
        let dados = {
            ano: ano,
            mes: mes,
            categoria: categoria,
            is_quantidade: isQuantidade,
            valor: parseFloat(valor || 0)
        };
        
        try{
          const response = await post(dados, `/gvendas/metas/`, null, 'addMeta');
          if(response && response.length){
            buscarBalancoDiario();
          }
          return true;
        }catch(err){
          // alert(JSON.stringify(err.response))
          // alert(JSON.stringify(dados))
          return false
        }
      },
      allowOutsideClick: () => !Swal.isLoading()
    }).then((result) => {
      if (result.isConfirmed) {
        Toast.fire({
            icon: "success",
            title: "Meta atualizada com sucesao"
        });
      }
    });
  }
  
  const MetasDiaria = () => {
    const data = new Date();
    const mes = data.getMonth();
    const hoje = data.getDate()-1;
    const ultimoDia = new Date(data.getFullYear(), data.getMonth() + 1, 0).getDate();
  
    // Verifique se balanco é válido antes de acessar suas propriedades
    if (!balanco || !balanco.metas || !balanco.total) {
      return 0; // Retorne um valor padrão, como 0, caso balanco seja inválido
    }
    
    const meta = balanco.metas[mes];
    const total_recebido = balanco.total[mes];
    let dias_restante = ultimoDia - hoje;
    const total_hoje = balanco.dias[hoje][mes];
    const total_que_falta = meta - (total_recebido - total_hoje);
  
    const result = total_que_falta / dias_restante;
    return result >= 0 ? result : 0;
  };
  
  
  return (
    <div>
      <div className="fs-5">{balanco?.titulo}</div>
      <div className="small text-muted">{balanco?.subtitulo}</div>
      <Row className="align-items-center py-3">
        <Col onClick={()=>carregarAnoMenu(-1)}>{anoMenu.anterior}</Col>
        <Col className="text-center fs-4">{anoMenu.atual}</Col>
        <Col className="text-end" onClick={()=>carregarAnoMenu(1)}>{anoMenu.proximo}</Col>
      </Row>
      <div className="py-3 text-center">
        <Form.Group controlId="formIsAcumulado" className="fs-5">
          <Form.Check 
            type="switch" 
            label="Balanço Acumulado"
            checked={isAcumulado}
            onChange={(e) => setIsAcumulado(e.target.checked)} 
          />
        </Form.Group>
        {!isSoQuantidade && (
          <Form.Group controlId="formIsQuantidade" className="fs-5">
            <Form.Check 
              type="switch" 
              label="Por Quantidade"
              checked={isQuantidade}
              onChange={(e) => setIsQuantidade(e.target.checked)} 
            />
          </Form.Group>
        )}
      </div>

      {balanco && (
        <>
          <div className="table-responsive">
            <Table className="table table-f table-bordered">
              <thead className="table-dark">
                <tr className="text-center">
                  <th scope="col">#</th>
                  {balanco?.meses?.map((item, index) => (
                    <th scope="col">{item}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {balanco?.dias?.map((item, dia) => (
                  <tr onClick={()=>setTableSelected(dia)} className={tableSelected === dia?'table-secondary':''} key={dia} >
                    <th className={`text-center table-${tableSelected === dia?'dark':'light'}`}>
                      {dia + 1}
                    </th>
                    {isAcumulado && item.map((valor, mes) => (
                      <td className="text-center" onClick={()=>{
                          if((isQuantidade && !balanco?.metas[mes]?.quantidade?.valor)||(!isQuantidade && !balanco?.metas[mes]?.valor?.valor)){
                            addMeta(ano, mes+1);
                          }
                      }}>
                        {isQuantidade?(<>
                          {valor!=null?parseInt(getSoma(dia, mes)):''}
                        </>):(<>
                          {valor!=null?parseFloat(getSoma(dia, mes)).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }).replace('R$','').trim():''}
                        </>)}
                      </td>
                    ))}
                    {!isAcumulado && item.map((valor, mes) => (
                      <td className="text-center" onClick={()=>{
                          if((isQuantidade && !balanco?.metas[mes]?.quantidade?.valor)||(!isQuantidade && !balanco?.metas[mes]?.valor?.valor)){
                            addMeta(ano, mes+1);
                          }
                      }}>
                        {isQuantidade?(<>
                          {valor!=null?parseInt(valor.quantidade||0):''}
                        </>):(<>
                          {valor!=null?parseFloat(valor.valor||0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }).replace('R$','').trim():''}
                        </>)}
                      </td>
                    ))}
                  </tr>
                ))}
                <tr class="table-secondary">
                  <th class="text-center table-dark">T</th>
                  {balanco?.total?.map((item, index) => (
                    <td class={`text-center ${isQuantidade?(!balanco?.metas[index]?.quantidade?.valor?"":item?.quantidade >= balanco?.metas[index]?.quantidade?.valor ?'table-success':'table-danger'):(!balanco?.metas[index]?.valor?.valor?"":item?.valor >= balanco?.metas[index]?.valor?.valor ?'table-success':'table-danger')}`}>
                      {isQuantidade?(<>
                          {item?.quantidade?parseInt(item?.quantidade||0):``}
                        </>):(<>
                          {item?.valor?parseFloat(item?.valor||0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }).replace('R$','').trim():``}
                      </>)}
                    </td>
                  ))}
                </tr>
                <tr class="table-dark">
                  <th class="text-center ">M</th>
                  {balanco?.metas?.map((item, index) => (
                    <td onClick={()=>addMeta(ano, index+1, (isQuantidade?item?.quantidade?.valor:item?.valor?.valor))} className={`text-center`}>
                      {isQuantidade?(<>
                          {item?.quantidade?.valor?parseInt(item.quantidade?.valor||0):'-'}
                        </>):(<>
                          {item?.valor?.valor?parseFloat(item.valor?.valor||0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }).replace('R$','').trim():'-'}
                      </>)}
                    </td>
                  ))}
                </tr>
                <tr class="table-light">
                  <th class="text-center ">P</th>
                  {balanco?.metas?.map((item, index) => (
                    <td onClick={()=>addMeta(ano, index+1)} className={`text-center`}>
                        {isQuantidade ? (
                          <>
                            {item?.quantidade?.progresso != null
                              ? !balanco?.metas[index]?.quantidade?.valor? "" : `${parseFloat(item.quantidade.progresso)}%`
                              : ''}
                          </>
                        ) : (
                          <>
                            {item?.valor?.progresso != null
                              ? !balanco?.metas[index]?.valor?.valor? "" : `${parseFloat(item.valor.progresso)}%`
                              : ''}
                          </>
                        )}
                    </td>
                  ))}
                </tr>
              </tbody>
            </Table>
          </div>
        </>
      )}

      <div>
        <p className="text-muted small">
            *Para alterar o M, toque na célula para habilitar a edição
            </p>
              {ano == new Date().getFullYear() && (
                <>
                  <b>Mês <span >{
                  isQuantidade?(
                    parseInt(balanco?.metas[new Date().getMonth()]?.quantidade?.valor||0)
                  ):(
                    parseFloat(balanco?.metas[new Date().getMonth()]?.valor?.valor||0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })
                  )
                  }</span></b>
                  <ul>
                      <li>
                          Até agora: <span >{
                          isQuantidade?(
                            parseInt(balanco?.total[new Date().getMonth()]?.quantidade||0)
                          ):(
                            parseFloat(balanco?.total[new Date().getMonth()]?.valor||0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })
                          )}</span>
                      </li>
                      <li>
                          Progresso: <span >{
                          isQuantidade?(
                            `${parseFloat(balanco?.metas[new Date().getMonth()]?.quantidade?.progresso||0)}%`
                          ):(
                            `${parseFloat(balanco?.metas[new Date().getMonth()]?.valor?.progresso||0)}%`
                          )}</span>
                      </li>
                      <li>
                          Por dia: <span >{
                          isQuantidade?(
                            parseInt(balanco?.metas[new Date().getMonth()]?.quantidade?.diario||0)
                          ):(
                            parseFloat(balanco?.metas[new Date().getMonth()]?.valor?.diario||0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })
                          )}</span>
                      </li>
                  </ul>
                </> 
              )}
          <p>
            <b>Total do ano</b> <span>{
              isQuantidade ? (
                (balanco?.total || []).reduce((acc, item) => acc + (item?.quantidade || 0), 0)
              ) : (
                ((balanco?.total || []).reduce((acc, item) => acc + (item?.valor || 0), 0))
                  .toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
              )
            }</span>
          </p>
        </div>
    </div>
  );
}

export default BalancoDiario